// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__-7HQi","info":"Note_info__26Yqv","note":"Note_note__17ZvD","actions":"Note_actions__2O2zm"};